import * as React from 'react';
import * as styles from './AnimationFade.css';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
export function AnimationFade(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ReactCSSTransitionGroup, {
    transitionEnterTimeout: 300,
    transitionLeaveTimeout: 300,
    transitionName: {
      enter: styles['notification__animation-enter'],
      enterActive: styles['notification__animation-enter-active'],
      leave: styles['notification__animation-leave'],
      leaveActive: styles['notification__animation-leave-active']
    }
  }, children);
}